import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia.commercial.additionalinformation.documentupload.Unable to Download',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    otherDocument: {
        id: 'twia.commercial.additionalinformation.documentupload.Other document',
        defaultMessage: 'Other document',
    },
    badFileTypeTitle: {
        id: 'twia.commercial.additionalinformation.documentupload.Bad File Type Title',
        defaultMessage: 'Bad File Format',
    },
    badFileTypeBody: {
        id: 'twia.commercial.additionalinformation.documentupload.Bad File Type Body',
        defaultMessage: 'Please upload a supported file format: .avi, .bmp, .doc, .docm, .docx, .dot, .gif, .jpeg, .jpg, .mov, .mpg, .pdf, .png, .ppt, .pptx, .rtf, .tif, .tiff, .txt, .wav, .wmv, .xls, .xlsx.',
    },
});
